import { ThumbsDownFilled, ThumbsUpFilled } from '@heidi/design-system/feedback-thumbs';
import type { TranslationKey } from '@heidi/runtime/i18n';
import { type LucideIcon, ThumbsDown, ThumbsUp } from 'lucide-react';
import type { FeedbackType } from '../components/customer-feedback';

type FeedbackConfig = {
  icon: typeof ThumbsUp;
  filledIcon: LucideIcon;
  // colors: string;
  title: string;
  placeholder: string;
  label: string;
  alignOffset: number;
};

export const createFeedbackConfig = (
  t: (key: TranslationKey) => string
): Record<NonNullable<FeedbackType>, FeedbackConfig> => ({
  positive: {
    icon: ThumbsUp,
    filledIcon: ThumbsUpFilled,
    // colors: 'bg-green-50 text-green-600 hover:text-green-700',
    title: t('feedback.askAiFeedback.positive.title'),
    placeholder: t('feedback.askAiFeedback.positive.placeholder'),
    label: t('feedback.askAiFeedback.positive.label'),
    alignOffset: -25,
  },
  negative: {
    icon: ThumbsDown,
    filledIcon: ThumbsDownFilled,
    // colors: 'bg-red-50 text-red-600 hover:text-red-700',
    title: t('feedback.askAiFeedback.negative.title'),
    placeholder: t('feedback.askAiFeedback.negative.placeholder'),
    label: t('feedback.askAiFeedback.negative.label'),
    alignOffset: -45,
  },
});

export const getButtonClassName = (
  feedbackType: FeedbackType,
  isSelected: boolean,
  baseClasses: string
  // config: ReturnType<typeof createFeedbackConfig>
) => {
  if (isSelected && feedbackType) {
    return `${baseClasses}}`;
  }
  return baseClasses;
};
